import viewImpressionLogs from '@pc/components/ViewImpressionLogs'

// パーツインプレッション計測用
export function widgetImpression() {
  const trigger = document.getElementById('js-detail-widget-impression')
  const widgets = [].slice.call(document.getElementsByClassName('js-detail-widget'))
  if (trigger === null || widgets.length === 0) return

  widgets.forEach((el: HTMLElement) => {
    const widgetValue = el.dataset.value
    const rect = el.getBoundingClientRect()
    const top = rect.top + window.pageYOffset
    const widgetDisplayPosition = top + el.offsetHeight

    window.addEventListener('scroll', () => {
      const bottomPosition = window.pageYOffset + screen.availHeight

      if (!el.classList.contains('is-shown') && bottomPosition > widgetDisplayPosition) {
        el.classList.add('is-shown')
        gtag('event', 'load', {
          event_label: 'detail-widget',
          event_element: 'detail-widget-pc',
          event_value: widgetValue
        })
      }
    })
  })
}

// JSENG-2832 GA4のインプレッションログ実装(詳細画面のloadタイプ)
export function workDetailLoadImpressionLogs() {
  interface WorkItem {
    item_id: string
    index: number
    location_id?: string
  }

  const workItems = document.querySelectorAll('.js-recommend-items')
  if (workItems.length === 0) return

  workItems.forEach((item) => {
    const workItem = item.querySelectorAll<HTMLElement>('.js-recommend-item')
    if (workItem.length === 0) return

    const items: WorkItem[] = []

    workItem.forEach((el) => {
      const dataAttr = el.dataset?.impression
      if (dataAttr === undefined) return
      items.push(JSON.parse(dataAttr) as WorkItem)
    })

    if (items.length === 0) return

    window.gtag('event', 'view_item_list', {
      impression_type: 'load',
      item_count: workItem.length,
      max_item_count: 10,
      total_item_count: 0, // 必須項目だが、MBでは使用しないとのことなので0を指定
      page_num: 1,
      items
    })
  })
}

// JSENG-2850 GA4のインプレッションログ実装(詳細画面のviewタイプ)
export function workDetailViewImpressionLogs() {
  const workItems = document.querySelectorAll('.js-recommend-items')
  if (workItems.length === 0) return

  workItems.forEach((item) => {
    const workItem = item.querySelectorAll<HTMLElement>('.js-recommend-item')
    const workItemCount = workItem.length
    if (workItemCount === 0) return

    viewImpressionLogs({
      items: workItem,
      itemCount: workItemCount,
      maxItemCount: 10,
      totalItemCount: 0, // 必須項目だが、MBでは使用しないとのことなので0を指定
      pageNum: 1
    })
  })
}
